module.exports = __webpack_public_path__ + "img/banner_compliance_1920x783px.81adfa37.webp";